// extracted by mini-css-extract-plugin
export var deliveryRow = "_r5-a";
export var fixedHeight = "_r5-4";
export var freightLogo = "_r5-9";
export var fullWidth = "_r5-3";
export var priceColumn = "_r5-5";
export var radioSelected = "_r5-7";
export var radioUnselected = "_r5-6";
export var selectedOption = "_r5-2";
export var selectedOptionContainer = "_r5-1";
export var selection = "_r5-0";
export var tallSkeletonText = "_r5-8";